import { render, staticRenderFns } from "./PxResendSurvey.vue?vue&type=template&id=07b7a693&scoped=true"
import script from "./PxResendSurvey.vue?vue&type=script&lang=js"
export * from "./PxResendSurvey.vue?vue&type=script&lang=js"
import style0 from "./PxResendSurvey.vue?vue&type=style&index=0&id=07b7a693&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b7a693",
  null
  
)

export default component.exports